module.exports = __webpack_public_path__ + "static/media/king-of-string.a887dc58.jpg";